import * as React from 'react';
import { hot } from 'react-hot-loader';
import { observer } from 'mobx-react';
import { isMobileOnly } from 'react-device-detect';

import { cookieEnabled } from './config';
import { AppModel } from './app/appModel';

import './styles/App.css';

import { Heading } from './components/Heading';
import { LandingMobile } from './components/LandingMobile';
import { VisitedSchools } from './components/VisitedSchools';
import { SchoolNotFoundHint } from './components/SchoolNotFoundHint';
import { Footer } from './components/Footer';
import { Search } from './components/Search';
import { text } from './common/text';

export interface AppProps {
  model: AppModel;
}

@observer
class App extends React.Component<AppProps> {
  constructor(props: AppProps) {
    super(props);

    console.info(this.getBuildInfo());
  }

  componentDidMount() {
    window.document.title = `WebUntis ` + text('LBL_SCHOOL_SEARCH_TITLE');
  }

  render(): React.ReactNode {
    const params = new URLSearchParams(window.location.search);
    const hint = params.get("hint");
    const showSchoolNotFoundHint = hint === 'school_not_found';
    const headingPaddingBottom = showSchoolNotFoundHint ? '2rem' : 155;

    return (
      <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
        {!isMobileOnly && (
          <div style={{ width: 70, paddingTop: 16, backgroundColor: '#fff', textAlign: 'center' }}>
            <img width={44} src="img/logo.svg" />
          </div>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexGrow: 1,
            backgroundImage: `linear-gradient(206.57deg, #F3F5F7 0%, #BFC8CF 100%)`,
            overflowY: 'auto',
          }}
        >
          <Heading
            style={isMobileOnly
              ? { paddingTop: 40, paddingBottom: 32 }
              : { paddingTop: 100, paddingBottom: headingPaddingBottom }}
          />

          <main
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              alignSelf: 'stretch',
              paddingLeft: 16,
              paddingRight: 16,
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: 520,
                marginBottom: 24,
              }}
            >
              <LandingMobile>
                {showSchoolNotFoundHint && <SchoolNotFoundHint/>}
                <Search getSchools={this.props.model.getSchools} selectSchool={this.props.model.selectSchool} />

                {cookieEnabled && (
                  <VisitedSchools
                    {...{
                      visitedSchoolOptions: this.props.model.visitedSchools.slice(),
                      onRemoveVisitedSchoolOption: this.props.model.deleteSchool,
                    }}
                  />
                )}
              </LandingMobile>
            </div>
          </main>

          <Footer />
        </div>

        {this.renderBuildInfo()}
      </div>
    );
  }

  /**
   * wir wollen die build info ganz "einfach" als kommentar in die html seite schreiben;
   * dies ist in react aber gar nicht so einfach...
   * @returns {React.ReactNode}
   */
  renderBuildInfo(): React.ReactNode {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: '<!--' + this.getBuildInfo() + '-->',
        }}
      />
    );
  }

  /**
   * Dies dürfte das kleinste übel sein: der build erzeugt eine javascript datei "buildinfo.js", die eine globale
   * variablenzuweisung (im window objekt) enthält.
   * (require würde (auch mit json-loader) schon zur compile zeit erfolgen; der build würde eine buildinfo.json aus /src
   * mit minifizieren...
   * axios/fetch etc wären hier mühsam weil asynchron; das ergebnis sollte dann auch gecached werden.)
   *
   * @returns {string}
   */
  getBuildInfo(): string {
    let res: string = 'no build info';
    try {
      const globalObject = window['wu_schulsuche'];
      if (globalObject) {
        res = 'build time: ' + globalObject['BUILD_TIME_FORMATTED'] + ' commit: ' + globalObject['GIT_COMMIT_HASH'];
      }
    } catch (e) {
      console.warn(e);
    }
    return res;
  }
}

export default hot(module)(App);



// WEBPACK FOOTER //
// ./src/App.tsx